import type { ReactNode, SVGProps } from "react";

export function ExternalLinkIcon({ ...props }: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="11"
			viewBox="0 0 11 11"
			width="11"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.29167 1.79175H1.79167C1.48225 1.79175 1.1855 1.91466 0.966709 2.13346C0.747916 2.35225 0.625 2.649 0.625 2.95841V8.79175C0.625 9.10117 0.747916 9.39791 0.966709 9.61671C1.1855 9.8355 1.48225 9.95842 1.79167 9.95842H7.625C7.93442 9.95842 8.23117 9.8355 8.44996 9.61671C8.66875 9.39791 8.79167 9.10117 8.79167 8.79175V5.29175"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M4.70801 5.875L9.95801 0.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M7.0415 0.625H9.95817V3.54167"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
